import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PilotsService } from '../../../shared/services/pilots.service';
import { IPilotAdmin } from '../../pay-scales/pay-scales.types';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseComponent } from '../../base.component';
import { AlertService } from '../../../core';
import { MatTableDataSource } from '@angular/material/table';

@Component({
	selector: 'app-dialog-set-admin',
	styleUrls: ['./set-admin-dialog.component.scss'],
	templateUrl: './set-admin-dialog.component.html'
})
export class SetAdminDialogComponent extends BaseComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<SetAdminDialogComponent>,
		protected alertService: AlertService,
		private pilotsService: PilotsService
	) {
		super(alertService);
	}

	public employees: MatTableDataSource<IPilotAdmin>;
	public isLoading: boolean = true;
	public filterText: string = '';

	ngOnInit(): void {
		this.isLoading = true;
		this.pilotsService.getPilotsWithAdminData().subscribe(
			data => {
				const employees: IPilotAdmin[] = this.sortAndFilter(data);
				this.employees = new MatTableDataSource<IPilotAdmin>(employees);
				this.isLoading = false;
			},
			(error: HttpErrorResponse) => {
				this.handleError(error);
			}
		);
	}

	public adminStateChanged(employee: IPilotAdmin): void {
		employee.isAdmin = !employee.isAdmin;
		this.pilotsService.setPilotAdminStatus(employee.employeeId, employee.isAdmin).subscribe(
			() => {
				// success
			},
			(error: HttpErrorResponse) => {
				this.handleError(error);
			}
		);
	}

	public filterEmployees(): void {
		this.employees.filter = this.filterText.trim().toLowerCase();
	}

	close(): void {
		this.dialogRef.close();
	}

	private sortAndFilter(data: IPilotAdmin[]): IPilotAdmin[] {
		// don't allow the Admin User to be managed on this screen
		let results: IPilotAdmin[] = data.filter(pilot => pilot.emailAddress !== 'it-ops@activeaero.com');

		results = results.sort((a: IPilotAdmin, b: IPilotAdmin) => {
			const aName: string = `${a.lastName} ${a.firstName}`.toUpperCase();
			const bName: string = `${b.lastName} ${b.firstName}`.toUpperCase();
			if (aName < bName) {
				return -1;
			}
			if (aName > bName) {
				return 1;
			}
			return 0;
		});

		return results;
	}
}
